module.exports = __webpack_public_path__ + "/images/nosotros-trabaja.72d83ae.jpg";